<template>
  <div class="page">
    <div v-loading="loadingDetail">
      <p class="page-next">
        <a class="link-item" href="/workorder/myworkorder">
          <span class="back-last"></span>
        </a>
        <span>工单详情</span>
      </p>
      <div class="wo-detail-wrap">
        <div class="wo-status">
          <h2 class="w-d-detail">{{workOrderDetail.statuDesc}}</h2>
          <p v-if="workOrderDetail.statu==0" class="wo-status-desc">提问处理中，讯飞工程师会在{{timeRange}}内回复您。工作时段为法定工作日的9：00-17：00，中午高峰期会有适当的延迟，敬请谅解。</p>
          <div class="w-s-addition">
            <span>工单号：{{workOrderDetail.code}}</span>
            <span>|</span>
            <span>提交时间：{{workOrderDetail.createtime}}</span>
          </div>
        </div>
        <div class="wo-record-wrap">
          <ul class="wo-record">
            <li class="record-response new-t" v-for="item in workOrderDetail.message||[]" :key="item.content">
              <div class="record-item-avatar">
                <img v-if="item.opt==0" src="../../../../assets/iflytek-engineer.png" />
                <img v-if="item.opt==1" src="../../../../assets/question.png" />
              </div>
              <div class="record-info">
                <p class="response-name">{{item.opt==0?workOrderDetail.customerType:"您"}}</p>
                <p class="response-content" v-html="item.content"></p>
                <p class="response-attachment">
                  <span v-for="attachmentItem in item.attachments" :key="attachmentItem.url">
                    <div><a :href="attachmentItem.url" target="_blank"><i class="el-icon-document"></i> {{attachmentItem.name}}</a></div>
                  </span>
                </p>
                <p class="response-date">{{item.createtime}}</p>
              </div>
            </li>
            <li class="record-response">
              <div class="record-item-avatar">
                <img src="../../../../assets/question.png" />
              </div>
              <div class="record-info">
                <p class="response-name">您</p>
                <p class="response-content">{{workOrderDetail.title}}</p>
                <p class="response-content" v-html="workOrderDetail.detail"></p>
                <p class="response-attachment">
                  <span v-for="attachmentItem in workOrderDetail.attachments" :key="attachmentItem.url">
                    <div><a :href="attachmentItem.url" target="_blank"><i class="el-icon-document"></i> {{attachmentItem.name}}</a></div>
                  </span>
                </p>
                <p class="response-date">{{workOrderDetail.createtime}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="workOrderDetail.statu==2&&!isShowAppend" class="detail-option">
        <el-button type="primary" @click="finishWorkOrder()">确认结单</el-button>
        <span>如未解决问题，请
          <a href="javascript:void(0)" @click="showAppend">继续留言</a>
        </span>
      </div>
      <div class="append-content" v-if="isShowAppend||workOrderDetail.statu==0||workOrderDetail.statu==1">
        <el-form :model="appendForm" ref="appendForm" label-width="0px" class="demo-ruleForm">
          <el-form-item label=" " prop="content">
            <el-input class="follow-upload" v-model="appendForm.content" type="textarea" :autosize="{ minRows: 4, maxRows: 8}" placeholder="请填写问题描述" auto-complete="off"></el-input>
            <div v-show="false">
              <el-input v-model="appendForm.fileUrl" type="hidden"></el-input>
            </div>
            <div class="upload-bottom">
              <el-upload 
                class="upload-demo" 
                action="/dashboard/workorder/upload" 
                accept=".jpg,.png,.txt,.rar,.zip,.doc,.xls,.docx,.xlsx,.pdf"
                :before-upload="beforeAvatarUpload"
                :multiple="true"
                :on-change="handleChange" 
                :on-remove="handleFileRemove" 
                :file-list="workOrderFiles" >
                <el-button class="issue-file-btn" size="small">上传文件</el-button>
                <span class="file-limit-desc">上传附件支持jpg、png、txt、rar、doc、xls、docx、xlsx、pdf格式，最大不超过5M</span>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
        <div class="detail-option">
          <el-button type="primary" @click="submitAppend('appendForm')">提交追问</el-button>
        </div>
      </div>
    </div>
    <div class="confirm-wo">
      <el-dialog style="width:1000px;margin:0 auto" title="确认结单" :close-on-click-modal='false' :visible.sync="dialogVisible" :before-close="handleClose">
        <div class="confirm-tip">
          <span>
            <i class="el-icon-circle-check confirm-icon"></i>
          </span>确认结单后，该问题流程将关闭，请对我们的服务做出评价</div>
        <div class="confirm-form">
          <el-form :model="form" :rules="formRules" ref="form" label-width="80px" class="demo-ruleForm">
            <el-form-item :class="(form.score<=4 && !form.tag.length)?'rate-area-wrong':'rate-area'" label="服务评价" prop="score">
              <el-rate v-model="form.score">
              </el-rate>
            </el-form-item>
            <el-form-item prop="tag">
             <el-tag
                :key="tag.value"
                v-for="tag in commentTags"
                :disable-transitions="false"
                :class="form.tag.includes(tag.value+commentLevel)?'selected-tag':'comment-tag'"
                @click="labelClick(tag)"
                >
                {{tag.text+commentLevel}}
              </el-tag>
            </el-form-item>
            <el-form-item label="评价内容" prop="content">
              <el-input maxlength="200" v-model="form.content" type="textarea"  resize="none" placeholder="请输入评价内容 不超过200字" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div class="confirm-btn-wrap">
            <el-button class="confirm-submit-btn" type="primary" @click="submitRate('form')">确定</el-button>
          </div>
        </div>
        <div>
          <span></span>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ajax from 'api/my-work-order'
import { mixin as clickaway } from 'vue-clickaway'
import * as utils from 'libs/utils'
import { Store } from 'vuex'
export default {
  name: 'Create',
  mixins: [clickaway],
  data() {
    var validateTag = (rule, value, callback) => {
      if (!this.form.tag.length && this.form.score<=4) {
        callback(new Error('请选择至少一个标签'))
      }
      callback()
    }
    return {
      workOrderFiles: [],
      rateText: ["无语了", "一般般", "还行吧", "满意", "非常棒，无可挑剔"],
      isShowAppend: false,
      dialogVisible: false,
      loadingDetail: false,
      workOrderDetail: {},
      form: {
        score: 5,
        content: "",
        tag:[],
      },
      formRules:{
        score: [
         { validator: validateTag, trigger: 'change' },
        ],
        content: [
         { max: 200, message: '不超过200个字', trigger: 'blur' },
         { pattern: /^((?![<>\/\\]).)+$/, message: '不可包含特殊字符', trigger: 'change' },
        ]
      },
      appendForm: {
        content: ""
      },
      commentTags:[
        {text:'服务态度',value:'服务态度'},
        {text:'专业技能',value:'专业技能'},
        {text:'产品功能',value:'产品功能'},
      ],
      commentLevel: '好'
    }
  },
  computed: {
    baseUrl() {
      return Url[Mode].baseUrl
    },
    certificateType() {
      return this.$store.state.auth.certificateType;// 1：个人（包括个人和学生）；2：企业；3：创业；4：未通过；5：审核中
    },
    isVip(){
      let vipInfo = this.$store.state.auth.vip
      return vipInfo
    },
    timeRange() {
      let  vip = this.isVip
      let  type = this.certificateType
      let range = '三个工作日'
      if(vip === 0){
       range = (type === 1)
        ? "1个工作日"
        : type === 2
        ? "3小时"
        : "3个工作日"
      }else{
       range = (vip === 2)
        ? "60分钟": "60分钟"
      }
      return range
    },
    replyName(){
      let  vip = this.isVip
      let replyer = '客户服务专员'
      vip === 1?
      replyer = '中级技术支持工程师'
      :vip ===2?
      replyer = '资深技术支持工程师'
      :'客户服务专员'
      return replyer
    }
  },
  watch:{
    'form.score'(n,o){
      // this.commentLevel = n>3?'好':n===3?'一般':n<3?'差':''
      this.commentLevel = n>4?'好':n===4?'稍弱':n===3?'一般':n<3?'差':''
      this.form.tag.length = 0
      this.$refs.form.validateField('score')
    }
  },
  created() {
    //初始化平台类型
    this.getWorkOrderDetail(this.$route.query.id);
  },
  methods: {
    beforeAvatarUpload (file) {
      let allowFix=["jpg","png","txt","rar","zip","doc","xls","docx","xlsx","pdf"];
      let fileFix=file.name.substring(parseInt(file.name.lastIndexOf("."))+1,file.name.length);
      const allowFormate = (allowFix.filter(item=>item==fileFix)).length==0?false:true;
      const isLt5M = file.size / 1024 / 1024 <= 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB')
      }
      if (!allowFormate) {
        this.$message.error('上传图片只能是 jpg/png/txt/rar/zip/doc/xls/docx/xlsx/pdf 格式')
      }
      return isLt5M&&allowFormate;
    },
    handleChange(file, fileList) {
      if (file.status == "success" && file.response.code == 0) {
        this.workOrderFiles = fileList
      }
    },
    handleFileRemove(file, fileList) {
      this.workOrderFiles = fileList
    },
    showAppend() {
      this.isShowAppend = true;
    },
    finishWorkOrder() {
      this.dialogVisible = true;
    },
    openWorkOrder(row) {
      this.loadingDetail = true;
      this.getWorkOrderDetail(row.id);
    },
    getWorkOrderDetail(id) {
      ajax.getWorkOrderDetail({ id: id }).then(result => {
        if (result.code == 0 && result.data.code == 0) {
          this.workOrderDetail = result.data.data;
          this.loadingDetail = false;
        }
      }).catch(errMsg => { })
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submitAppend(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = utils.copy(this.appendForm);
          params.opt = 0;
          if(params.content.length>200){
            this.$message.error("追问内容不能超过200个字符");
            return;
          }
          if (!params.content) {
            this.$message.error("追问内容不能为空");
            return;
          }
          if (this.workOrderFiles && this.workOrderFiles.length) {
            let tempWorkOrderFiles = this.workOrderFiles || [];
            let tempName = [];
            let tempUrl = [];
            let tempSize = [];

            tempWorkOrderFiles.map(fileItem => {
              (fileItem.response.data||[]).map(responseFileItem=>{
                tempName.push(responseFileItem.name);
                tempUrl.push(responseFileItem.url);
                tempSize.push(responseFileItem.size);
              })
            });
            params["attachment_names"] = tempName.join(",");
            params["attachment_urls"] = tempUrl.join(",");
            params["attachment_sizes"] = tempSize.join(",");
          }
          params["id"] = this.$route.query.id;
          ajax.submitAppend(params).then(result => {
            if (result.code == 0 && result.data.code == 0) {
              this.isShowAppend = false;
              this.$message.success("追问成功");
              this.workOrderFiles = [];
              this.getWorkOrderDetail(this.$route.query.id);
              this.$refs[formName].resetFields();
            } else {
              this.$message.error(result.desc);
            }
          }).catch(errMsg => {
            console.log(errMsg)
          }
            )
        } else {
          return false;
        }
      });
    },
    labelClick(tag){
      let tagValue = tag.value+this.commentLevel
      if(this.form.tag.includes(tagValue)){
        this.form.tag = this.form.tag.filter((item)=>{
            return item !== tagValue
        })
      }else{
          this.form.tag.push(tagValue)
      }
      this.$refs.form.validateField('score')
    },
    submitRate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var params = utils.copy(this.form)
          params["id"] = this.$route.query.id;
          params["tag"] = ((params.tag).toString()).replace(/,/g,";")
          let appendParam =  utils.copy(params)
          appendParam["opt"] = 1;
          ajax.submitAppend(appendParam).then(result => {
            if (result.code == 0 && result.data.code == 0) {
              ajax.submitRate(params).then(result => {
                if (result.code == 0 && result.data.code == 0) {
                  this.dialogVisible = false;
                  this.$message.success("问题确认完成");
                  this.getWorkOrderDetail(this.$route.query.id);
                  this.$refs[formName].resetFields();
                } else {
                  this.$message.error(result.desc);
                }
              }).catch(errMsg => { })
            }
          }).catch(errMsg => { })
        } else {
          return false;
        }
      });
    }
  }
}
</script>
<style lang="stylus">
  @import '~styl/mixins'
  pageBase()
  .rate-area
    margin-bottom: 0
  .selected-tag 
    border-color: #409eff
    background: #fff
    margin: 0 .1rem auto 0
    cursor: pointer
    font-weight: 600
  .comment-tag
    background: #fff
    margin: 0 .1rem auto 0
    cursor: pointer
    &:hover
      border-color: #d9d9d9;
  .append-content
    margin-top .1rem
  .follow-upload textarea
    border-bottom-left-radius 0px
    border-bottom-right-radius 0px
  .upload-bottom
    overflow: hidden;
    height: auto;
    padding 10px
    width 100%
    background #F5F6F8
    border solid 1px #BFCBD9
    border-bottom-left-radius 4px
    border-bottom-right-radius 4px
    border-top 0;
    .issue-file-btn
      margin-right .1rem
    .file-limit-desc
      color #666666;
      font-size 12px
  .confirm-wo
    color #333333;
    .el-dialog__body
      margin .1rem;
      border-top solid 1px #eee;
      padding .2rem .1rem
  .table-empty
    background #edeff2
    height .4rem;
    width 4rem;
    line-height .4rem
    border solid 1px #dbdcdf
    .link-item 
      color #3592f2
  .detail-option
    margin-top .2rem
    a
      color #3592f2
  .wo-detail-wrap
    color #333333
    h2,& > ul,.wo-record > li
      list-style none
      margin 0
      padding 0
  .wo-record-wrap
    width 100%;
    padding .15rem
    .wo-record > li
      height auto
      overflow hidden
      padding .2rem 5px 
      .record-item-avatar
        width .7rem
        height 100%
        float left
        img
          width 0.61rem
          height 0.61rem
      .record-info
        margin-left .8rem
        .response-name
          color #333333
          font-weight bold
        .response-content
          color #454545
          word-break: break-all
        .response-date
          margin-top .2rem
          font-size 12px
          color #787878
    .wo-record
      blockquote
        margin: 0 0 10px;
        padding: 15px 20px;
        background-color: #f1f2f3;
        border-left: 5px solid #ccc;
        color: #666;
        font-style: italic;
      ul li
        list-style disc
      width 100%
      .record-response:first-child
        border-top none;
      .record-response
        border-top dashed 1px #B6BFD0
  .wo-status
    width 100%
    padding .15rem
    height auto;
    overflow hidden
    border-bottom:solid 1px #B6BFD0
    .w-d-detail
      margin-bottom .1rem
      font-size .2rem
      height .2rem
      line-height .2rem
      border-left solid 4px #2989EE
      text-indent .1rem;
      font-weight normal
    .wo-status-desc
      line-height .3rem
      text-indent .15rem
    .w-s-addition
      margin-top 10px
      padding-left .15rem
      color #666666
      font-size 12px;
      span
        margin-right .2rem
        line-height .3rem
  .confirm-icon
    margin-top 0.05rem
    color #3B94EF
    font-size .4rem;
    float left
    margin-right .1rem
  .confirm-tip
    line-height .25rem
    width 80%
    margin: 0 auto
    font-size 14px
    height auto
    overflow hidden
  .confirm-form
    border-top dashed 1px #dcdcdc
    padding-top .15rem
    width 90%
    margin: .1rem auto
    .confirm-btn-wrap
      text-align center
    .confirm-submit-btn
      margin: 0 auto
    .el-rate__icon
      font-size .3rem
  .page-next
    font-size: 0.18rem
    line-height: 0.24rem
    height .24rem;
    color: #324057
    padding-left: 0.05rem;
    .pn-title
      float left
    .back-last
      margin-right .1rem
      float left
      display inline-block
      width .2rem
      height .24rem
      background url(../../../../assets/last-page.png) 0% 50% no-repeat
  .wo-detail-wrap
    margin-top .2rem
    width 100%;
    height auto;
    overflow hidden
    border:solid 1px #B6BFD0
  .wo-table-wrap
    width 100%;
    height auto;
    overflow hidden;
    padding 10px;
    .table-option
      width 100%
      height .3rem
      margin-bottom .2rem
    .pager-wrap
      width 100%;
      height 35px;
      margin-top .2rem;
      text-align center
  a.table-detail
    color #2084ED;
  .create-wrap
    width: 6rem
    padding: .5rem 0
    .el-select
      width: 100%
    .el-checkbox
      line-height: .16rem
      a
        color: color-blue
    .el-button
      width: 50%
      margin-top: .2rem
  .response-attachment
    a
      color:#4F99FF
</style>


// WEBPACK FOOTER //
// app/components/Dashboard/WorkOrder/MyWorkOrder/Detail.vue